export const actionTypes = {
  REQUEST_START: 'MY_TAXES.TAXES.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'MY_TAXES.TAXES.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'MY_TAXES.TAXES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MY_TAXES.TAXES.REQUEST_FAILURE',
};

export function startRequest(payload) {
  return {
    type: actionTypes.REQUEST_START,
    payload,
  };
}

export function startRequestSkipLoading(objectIds) {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
    payload: objectIds,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
